import moment from 'moment'
export const rankLabel = [
  'ブロンズ',
  'シルバー',
  'ゴールド',
  'プラチナ',
  'ダイヤモンド',
  'ボーナス'
]
export const cardRankLabel = [
  'BRONZE CARD',
  'SILVER CARD',
  'GOLD CARD',
  'PLATINA CARD',
  'DIAMOND CARD',
  'BONUS CARD'
]
export const rankImage = [
  require('@/assets/img/stampHistory/rankmarks/Badge_BLONDZ.png'),
  require('@/assets/img/stampHistory/rankmarks/Badge_SILVER.png'),
  require('@/assets/img/stampHistory/rankmarks/Badge_GOLD.png'),
  require('@/assets/img/stampHistory/rankmarks/Badge_PLATINA.png'),
  require('@/assets/img/stampHistory/rankmarks/Badge_DIAMOND.png'),
  require('@/assets/img/stampHistory/rankmarks/Badge_BONUS.png')
]
export const cardColors = [
  require('@/assets/img/stampHistory/cards/RIREKI_BLONDZ.png'),
  require('@/assets/img/stampHistory/cards/RIREKI_SILVER.png'),
  require('@/assets/img/stampHistory/cards/RIREKI_GOLD.png'),
  require('@/assets/img/stampHistory/cards/RIREKI_PLATINA.png'),
  require('@/assets/img/stampHistory/cards/RIREKI_DIAMOND.png'),
  require('@/assets/img/stampHistory/cards/RIREKI_BONUS.png')
]
export const rankFontColor = [
  '#D0811D',
  '#9F9F9F',
  '#BFA417',
  '#7EABCD',
  '#080808',
  '#CC0009'
]
export const sumStampCount = stampData => {
  let count = 0
  stampData.stamp_cards.map(item => {
    item.stamps.map(stamp => {
      if (stamp.stamped_at !== '') {
        count++
      }
    })
  })
  return count
}
export const rankName = stampData => {
  const rankNumber =
    stampData.stamp_cards[stampData.stamp_cards.length - 1].card_type
  return rankLabel[rankNumber]
}
export const rankMark = stampData => {
  const rankNumber =
    stampData.stamp_cards[stampData.stamp_cards.length - 1].card_type
  return rankImage[rankNumber]
}
export const rankColor = stampData => {
  const rankNumber =
    stampData.stamp_cards[stampData.stamp_cards.length - 1].card_type
  return rankFontColor[rankNumber]
}
export const cardBackColor = stampData => {
  const rankNumber =
    stampData.stamp_cards[stampData.stamp_cards.length - 1].card_type
  return cardColors[rankNumber]
}

export const dataFormat = date => {
  return moment(date).format('YYYY年MM月DD日')
}

export const dataFormatYyyyMm = date => {
  return date ? moment(date, 'YYYYMM').format('YYYY年MM月') : ''
}
